<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>概览</el-breadcrumb-item>
    </el-breadcrumb>
    <el-main>
      <div class="websites_container">
        <el-card class="websites_dashboard">
          <div class="websites_echarts_box" id="chart1" v-loading="chart1Loading">

          </div>
        </el-card>
        <!-- <p class="text-extra-small">用 Element 快速搭建页面（辅助文字）</p>
            <p class="text-small">用 Element 快速搭建页面（正文小）</p>
            <p class="text-base">用 Element 快速搭建页面（正文）</p>
            <p class="text-medium">用 Element 快速搭建页面（小标题）</p>
            <p class="text-large">用 Element 快速搭建页面（标题）</p>
            <p class="text-extra-large">用 Element 快速搭建页面（主标题）</p> -->
        <div class="websites_operation_area">
          <el-card class="box-card" v-loading="websiteLoading">
            <div slot="header" class="clearfix">
              <span class="text-base">站点</span>
              <el-button type="primary" size="mini" style="float: right;"
                @click="$router.push('/websites/list')">站点管理</el-button>
            </div>
            <el-row class="text-small">
              <el-col :span="8">
                总数: <span class="blue text-large">{{ statistics.website.total }}</span>
              </el-col>
              <el-col :span="8">
                开启: <span class="blue text-large">{{ statistics.website.on }}</span>
              </el-col>
              <el-col :span="8">
                关闭: <span class="red text-large">{{ statistics.website.off }}</span>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" v-loading="domainLoading">
            <div slot="header" class="clearfix">
              <span class="text-base">域名</span>
              <img src="../../../assets/imgs/tencent.png" alt="" class="cloud_logo">
              <el-button type="primary" size="mini" style="float: right;"
                @click="$router.push('/websites/domains')">域名管理</el-button>
            </div>
            <el-row class="text-small">
              <el-col :span="8">
                总数: <span class="blue text-large">{{ statistics.domain.total }}</span>
              </el-col>
              <el-col :span="8">
                自动续费: <span class="blue text-large">{{ statistics.domain.auto_renew }}</span>
              </el-col>
              <el-col :span="8">
                即将到期: <span class="red text-large">{{ statistics.domain.expired_in_month }}</span>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" v-loading="dnspodLoading">
            <div slot="header" class="clearfix">
              <span class="text-base">域名托管</span>
              <img src="../../../assets/imgs/tencent.png" alt="" class="cloud_logo">
              <el-button type="primary" size="mini" style="float: right;"
                @click="$router.push('/websites/dnspod')">解析管理</el-button>
            </div>
            <el-row class="text-small">
              <el-col :span="8">
                总数: <span class="blue text-large">{{ statistics.dnspod.total }}</span>
              </el-col>
              <el-col :span="8">
                正常: <span class="blue text-large">{{ statistics.dnspod.normal }}</span>
              </el-col>
              <el-col :span="8">
                异常: <span class="red text-large">{{ statistics.dnspod.error }}</span>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" v-loading="sslLoading">
            <div slot="header" class="clearfix">
              <span class="text-base">证书</span>
              <img src="../../../assets/imgs/centos.png" alt="" class="cloud_logo">
              <el-button type="primary" size="mini" style="float: right;" @click="getSslStatistics()">刷新</el-button>
            </div>
            <el-row class="text-small">
              <el-col :span="8">
                总数: <span class="blue text-large">{{ statistics.ssl.total }}</span>
              </el-col>
              <el-col :span="8">
                近期更新: <span class="blue text-large">{{ statistics.ssl.recent_updated }}</span>
              </el-col>
              <el-col :span="8">
                即将到期: <span class="red text-large">{{ statistics.ssl.expired_in_month }}</span>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" v-loading="deployLoading">
            <div slot="header" class="clearfix">
              <span class="text-base">部署情况</span>
              <img src="../../../assets/imgs/aliyun.png" alt="" class="cloud_logo">
              <el-button type="primary" size="mini" style="float: right;" @click="getDeployStatistics()">刷新</el-button>
            </div>
            <el-row class="text-small">
              <el-col :span="8">
                总数: <span class="blue text-large">{{ statistics.deploy.total }}</span>
              </el-col>
              <el-col :span="8">
                成功: <span class="blue text-large">{{ statistics.deploy.success }}</span>
              </el-col>
              <el-col :span="8">
                失败: <span class="red text-large">{{ statistics.deploy.failed }}</span>
              </el-col>
            </el-row>
          </el-card>
        </div>
      </div>
    </el-main>
  </div>
</template>

<script>
import Nav from '../../Global/Nav.vue'
export default {
  name: 'Websites',
  components: {
    Nav
  },
  data() {
    return {
      uploadApi: this.$axios.defaults.baseURL + 'excel/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      websiteLoading: true,
      domainLoading: true,
      dnspodLoading: true,
      sslLoading: true,
      deployLoading: true,
      statistics: {
        website: {
          total: '-',
          on: '-',
          off: '-'
        },
        domain: {
          total: '-',
          auto_renew: '-',
          expired_in_month: '-'
        },
        dnspod: {
          total: '-',
          normal: '-',
          error: '-'
        },
        ssl: {
          total: '-',
          recent_updated: '-',
          expired_in_month: '-'
        },
        deploy: {
          total: '-',
          success: '-',
          failed: '-'
        }
      },
      chart1Loading: true
    }
  },
  async mounted() {
    await Promise.all([
      this.getWebsiteStatistics(),
      this.getDomainStatistics(),
      this.getDnspodStatistics(),
      this.getSslStatistics(),
      this.getDeployStatistics()
    ]);
    this.drawChart1();
  },
  methods: {
    getWebsiteStatistics() {
      this.websiteLoading = true;
      this.$axios.get(`/websites/backend/statistics?type=website`).then((response) => {
        this.websiteLoading = false;
        if (response.data.code === 200) {
          this.statistics.website = response.data.data;
        }
      });
    },
    getDomainStatistics() {
      this.domainLoading = true;
      this.$axios.get(`/websites/backend/statistics?type=domain`).then((response) => {
        this.domainLoading = false;
        if (response.data.code === 200) {
          this.statistics.domain = response.data.data;
        }
      });
    },
    getDnspodStatistics() {
      this.dnspodLoading = true;
      this.$axios.get(`/websites/backend/statistics?type=dnspod`).then((response) => {
        this.dnspodLoading = false;
        if (response.data.code === 200) {
          this.statistics.dnspod = response.data.data;
        }
      });
    },
    getSslStatistics() {
      this.sslLoading = true;
      this.$axios.get(`/websites/backend/statistics?type=ssl`).then((response) => {
        this.sslLoading = false;
        if (response.data.code === 200) {
          this.statistics.ssl = response.data.data;
        }
      });
    },
    getDeployStatistics() {
      this.deployLoading = true;
      this.$axios.get(`/websites/backend/statistics?type=deploy`).then((response) => {
        this.deployLoading = false;
        if (response.data.code === 200) {
          this.statistics.deploy = response.data.data;
        }
      });
    },
    async drawChart1() {
      var dom = document.getElementById('chart1');
      var chart = this.$echarts.init(dom);
      const dataCount = 100;
      const data = this.generateData(dataCount);
      let option = {
        title: {
          text: '此处用于接入数据统计',
          left: 10
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false
            },
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          bottom: 90
        },
        dataZoom: [
          {
            type: 'inside'
          },
          {
            type: 'slider'
          }
        ],
        xAxis: {
          data: data.categoryData,
          silent: false,
          splitLine: {
            show: false
          },
          splitArea: {
            show: false
          }
        },
        yAxis: {
          splitArea: {
            show: false
          }
        },
        series: [
          {
            type: 'bar',
            data: data.valueData,
            // Set `large` for large data amount
            large: true
          }
        ]
      };
      this.chart1Loading = false;
      chart.setOption(option);
    },
    generateData(count) {
      let baseValue = Math.random() * 1000;
      let time = +new Date(2011, 0, 1);
      let smallBaseValue;
      function next(idx) {
        smallBaseValue =
          idx % 30 === 0
            ? Math.random() * 700
            : smallBaseValue + Math.random() * 500 - 250;
        baseValue += Math.random() * 20 - 10;
        return Math.max(0, Math.round(baseValue + smallBaseValue) + 3000);
      }
      const categoryData = [];
      const valueData = [];
      for (let i = 0; i < count; i++) {
        categoryData.push(
          this.$echarts.format.formatTime('yyyy-MM-dd\nhh:mm:ss', time, false)
        );
        valueData.push(next(i).toFixed(2));
        time += 1000;
      }
      return {
        categoryData: categoryData,
        valueData: valueData
      };
    }
  },
  beforeDestroy() {
    clearInterval(this.intervals);
  }
}
</script>

<style scoped>
.websites_container {
  width: 98%;
  height: 80vh;
  overflow: auto;
  display: flex;
  justify-content: space-between;
}

.websites_dashboard {
  width: 78%;
  height: 668px;
  border: solid 1px rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.websites_operation_area {
  width: 20%;
}

.box-card {
  margin-bottom: 20px;
}

.websites_echarts_box {
  width: 100%;
  height: 550px;
  margin-top: 20px;
}

.cloud_logo {
  transform: translateY(1px);
  height: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/Modules/Websites/Index.vue